import LodPrdInfoView from "components/view/lod/prd/info";

const LodPrdInfoPage = () => {
  return <LodPrdInfoView />;
};

export default LodPrdInfoPage;
